import { useFooterSettingsStore } from "@/stores/use-footer-settings-store"
import { useEffect } from "react"

// `skip`: khi settings đã được fetch ở server và truyền xuống qua prop, không cần
// fetch lại ở client (tránh gọi API trùng).
export const useFooterSettings = (locale: string, skip = false) => {
  const settings = useFooterSettingsStore(state => state.settings)
  const loading = useFooterSettingsStore(state => state.loading)
  const fetchSettings = useFooterSettingsStore(state => state.fetchSettings)

  useEffect(() => {
    if (locale && !skip) {
      fetchSettings(locale)
    }
  }, [locale, fetchSettings, skip])

  return { settings, loading }
}
